export default {
  namespaced: true,
  state: {
    list: []
  },
  getters: {
    list(state) {
      return state.list
    }
  },
  mutations: {
    setList(state, payload) {
      state.list = payload.competitions
    },
    setShowResult(state, payload) {
      state.list = state.list.map(item => {
        if (item.id === payload.competitionId) {
          return {
            ...item,
            showResult: payload.showResult
          }
        }
        return item
      })
    }
  },
  actions: {
    updateList({commit}, {competitions}) {
      commit("setList", {competitions: competitions})
    },
    updateShowResult({commit}, {competitionId, showResult}) {
      commit("setShowResult", {competitionId: competitionId, showResult: showResult})
    }
  }
}
